import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Input } from '../../../../../common/html/input'
import { ScrollComponent } from '../../../../../common/scrollComponent'
import Tree from '../../../../../common/tree'
import { convertDataTree } from '../../../../../common/tree/helper'
import EventEmitter, {
  SHOW_POPUP_ERROR,
} from '../../../../../helpers/EventEmitter'
import classes from '../../../../index.module.scss'
import {
  selectIcb,
  selectVsicChecked,
  selectVsicTree,
  setVsic,
  setVsicChecked,
  setVsicTree,
} from '../../../store/slice'

const VsicTree = ({ vsics, customContainerStyle, customTreeStyle }) => {
  const dispatch = useDispatch()

  const checked = useSelector(selectVsicChecked)
  const vsicTree = useSelector(selectVsicTree)
  const icbIb = useSelector(selectIcb)

  const textSearch = UseI18n('settingPreferences.SEARCH_INDUSTRY')
  const industryUsedMessage = UseI18n('errorCommon.ONE_TYPE_OF_INDUSTRY_USED')

  const [valueSearch, setValueSearch] = useState('')

  const isDisableSelection = !!icbIb.length

  useEffect(() => {
    if (vsics.length) {
      dispatch(setVsicTree(convertDataTree(vsics, 'id', 'parentId')))
    }
  }, [vsics])

  const changeSearch = (e) => setValueSearch(e.target.value)

  const setVsicSelected = (items) => {
    dispatch(setVsic(items))
  }

  const setChecked = (items) => {
    if (isDisableSelection) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [industryUsedMessage],
      })
      return
    }
    dispatch(setVsicChecked(items))
  }

  return (
    <>
      <Input
        placeHolder={textSearch}
        containerStyle={{ height: '28px' }}
        value={valueSearch}
        onChange={changeSearch}
        noControl
      />
      <div className={classes.treeContainer} style={customContainerStyle}>
        {!!Object.keys(vsicTree).length && (
          <ScrollComponent>
            <div className={classes.tree}>
              <Tree
                treeData={vsicTree}
                idKey="id"
                nameKey="name"
                isHaveCheckbox={true}
                listChecked={checked}
                setListChecked={setChecked}
                valueSearch={valueSearch}
                setListParentChecked={setVsicSelected}
                disabledCheckDbClick={true}
                additionSearchKeys={['name', 'code']}
                customTreeStyle={customTreeStyle}
              />
            </div>
          </ScrollComponent>
        )}
      </div>
    </>
  )
}

VsicTree.propTypes = {
  vsics: PropTypes.array.isRequired,
}

export default VsicTree
